import { memo } from 'react';

import { Button } from 'design-system';
import { CornerDownLeftIcon } from 'lucide-react';

type ViewInOtherCatalogLinkProps = Readonly<{
  label: 'View in Spot' | 'View in Forward Curves';
  onClick: () => void;
}>;

const ViewInOtherCatalogLink = ({ label, onClick }: ViewInOtherCatalogLinkProps) => (
  <Button
    data-row-action
    size='sm'
    variant='link'
    onClick={event => {
      event.stopPropagation();
      onClick();
    }}
  >
    {label}
    <CornerDownLeftIcon />
  </Button>
);

export default memo(ViewInOtherCatalogLink);
